import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';

const connectionString = import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING ?? '';

/**
 * Application Insights クライアントインスタンス
 *
 * 接続文字列はビルド時に環境変数 VITE_APPLICATIONINSIGHTS_CONNECTION_STRING から埋め込まれる。
 * enableAutoRouteTracking は History API を監視するため、TanStack Router によるルート遷移も
 * ページビューとして自動収集される。
 */
export const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    // ヘッダのうち Authorization, X-API-Key, WWW-Authenticate は SDK 既定の ignoreHeaders で記録から除外される
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableUnhandledPromiseRejectionTracking: true,
    samplingPercentage: 100,
    distributedTracingMode: DistributedTracingModes.W3C,
    // 非推奨の unload イベントと bfcache を無効化しうる beforeunload イベントを使わせない
    disablePageUnloadEvents: ['unload', 'beforeunload'],
  },
});

// 接続文字列が未設定（ローカル開発時など）はテレメトリ送信を開始しない
if (connectionString !== '') {
  appInsights.loadAppInsights();
  // アプリケーションマップでバックエンドと区別できるようロール名を付与
  appInsights.addTelemetryInitializer((item) => {
    item.tags = item.tags ?? [];
    item.tags['ai.cloud.role'] = 'frontend';
  });
}
